/* eslint-disable */
import Vue from 'vue'
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import {
  mapGetters
} from 'vuex';
export default {
  name: 'algo-task-four',
  components: {
    DatePicker
  },
  props: [],
  data () {
    return {
      file4:null,
      inputImage4:null,
      uploadFileName4: '',
      uploadingLoader1:false,
      submitted:false,
      filetype4:'BrainTumors',
      resultData4:'',
      errMsgShow4:false,
      errMsg4:'',
      task4:'Brain tumor diagnosis',
      taskEditAble4:true,
      attribute4: {
        forecast_key:'',
        forecast_val: '',
        forecast_label: ''
      },
      attributes4: [{
        forecast_key:'x1',
        forecast_val: '1',
        forecast_label: 'Radius mean'
      },{
        forecast_key:'x2',
        forecast_val: '0',
        forecast_label: 'Texture mean'
      },{
        forecast_key:'x3',
        forecast_val: '1',
        forecast_label: 'Perimeter mean'
      },{
        forecast_key:'x4',
        forecast_val: '1',
        forecast_label: 'Area mean'
      },{
        forecast_key:'x5',
        forecast_val: '0',
        forecast_label: 'Smoothness mean'
      },{
        forecast_key:'x6',
        forecast_val: '0',
        forecast_label: 'Compactness mean'
      },{
        forecast_key:'x7',
        forecast_val: '0',
        forecast_label: 'Concavity mean'
      },{
        forecast_key:'x8',
        forecast_val: '0',
        forecast_label: 'Concave Points mean'
      },{
        forecast_key:'x9',
        forecast_val: '0',
        forecast_label: 'Symmetry mean'
      },{
        forecast_key:'x10',
        forecast_val: '0',
        forecast_label: 'Fractal Dimention mean'
      },{
        forecast_key:'x11',
        forecast_val: '0',
        forecast_label: 'radius se'
      },{
        forecast_key:'x12',
        forecast_val: '0',
        forecast_label: 'texture se'
      },{
        forecast_key:'x13',
        forecast_val: '0',
        forecast_label: 'perimeter se'
      },{
        forecast_key:'x14',
        forecast_val: '0',
        forecast_label: 'area se'
      },{
        forecast_key:'x15',
        forecast_val: '0',
        forecast_label: 'smoothness se'
      },{
        forecast_key:'x16',
        forecast_val: '0',
        forecast_label: 'compactness se'
      },{
        forecast_key:'x17',
        forecast_val: '0',
        forecast_label: 'concavity se'
      },{
        forecast_key:'x18',
        forecast_val: '0',
        forecast_label: 'concave points se'
      },{
        forecast_key:'x19',
        forecast_val: '0',
        forecast_label: 'symmetry se'
      },{
        forecast_key:'x20',
        forecast_val: '0',
        forecast_label: 'fractal dimention se'
      },{
        forecast_key:'x21',
        forecast_val: '0',
        forecast_label: 'radius worst'
      },{
        forecast_key:'x22',
        forecast_val: '0',
        forecast_label: 'texture worst'
      },{
        forecast_key:'x23',
        forecast_val: '0',
        forecast_label: 'perimeter worst'
      },{
        forecast_key:'x24',
        forecast_val: '0',
        forecast_label: 'area worst'
      },{
        forecast_key:'x25',
        forecast_val: '0',
        forecast_label: 'smoothness worst'
      },{
        forecast_key:'x26',
        forecast_val: '0',
        forecast_label: 'compactness worst'
      },{
        forecast_key:'x27',
        forecast_val: '0',
        forecast_label: 'concavity worst'
      },{
        forecast_key:'x28',
        forecast_val: '0',
        forecast_label: 'concave points worst'
      },{
        forecast_key:'x29',
        forecast_val: '0',
        forecast_label: 'symmetry worst'
      },{
        forecast_key:'x30',
        forecast_val: '0',
        forecast_label: 'fractal dimention worst'
      }],
      my_features_data4 :[],
      my_feature_label4:{},
      response_data:'',
      first_name4:'',
      last_name4:'',
      patient_name4:'', 
      patient_age4:'', 
      patient_gender4:'',
      patient_id4:'',
      patient_date4:'',
      inputAttrList4:[],
      local_Array4: {
        forecast_val: '',
        key:'',
        value: ''
      },
      algorithm_loader4:false,
      features4:'30',
      task_number:'',
      uploadImageFileName4:'',
      attrImgSrc:''
    }
  },
  computed: {
    ...mapGetters([
      'getInputAttrListGetters'
    ]),
    // getInputAttrListed1Fun() {
    //   this.$store.dispatch('getInputAttrListFun',{id:2}).then((res) => {
    //   this.inputAttrList4 = this.$store.getters.getInputAttrListGetters.data
    //   if(this.inputAttrList4 && this.inputAttrList4.length >= 1){
    //     this.features4 = this.inputAttrList4.length
    //   }else{
    //     this.features4 = this.attributes4.length
    //   }
    //   }).catch((err)=>{

    //   })
    //   return
    // }
  },
  beforeMount(){
    // this.getInputAttrListed1Fun
  },
  mounted () {
    // this.getInputAttrListed1Fun
  },
  methods: {
    resetFieldFun4(){
      this.uploadFileName4 = '';
      this.patient_name4 = '';
      this.first_name4 = '';
      this.last_name4 = '';
      this.patient_age4 = '';
      this.patient_gender4 = '';
      this.patient_id4 = '';
      this.patient_date4 = '';
      for(var i = 0; i < this.attributes4.length; i++){
        this.attributes4[i].forecast_val = ''
      }
      this.removeAttributesImage()
      this.$validator.reset();
    },
    handleImageFileUploaded4(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.inputImage4 = event.target.files[0];
        this.uploadImageFileName4 = this.inputImage4.name
        if (this.inputImage4.type.indexOf('image/') === -1) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.attrImgSrc = event.target.result;
          };
          reader.readAsDataURL(this.inputImage4);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      }
    },
    removeAttributesImage(){
      this.inputImage4 = null
      this.uploadImageFileName4= ''
      this.attrImgSrc = ''
    },
    handleFileUpload4(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file4 = event.target.files[0];
        this.files4 = this.$refs.file4.files[0];
        this.filesSize1 = this.$refs.file4.files[0].size;
        this.uploadFileName4 = this.files4.name
      }  else {
        this.uploadFileName4 = '';
      }
    },
    validateFileBeforeSubmit4(e) {
      $(window).scrollTop(0);
      this.my_features_data4 = [],
      this.my_feature_label4 = {}
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.algorithm_loader4 = true
          this.submitted1 = true;
          this.resultData4 = ''
          this.uploadingLoader1 = true
          this.errMsgShow4 = false
          this.errMsg4 = ''
          let formData = new FormData();
          formData.append('name', this.task4);
          formData.append('patient_name', this.first_name4 + ' ' + this.last_name4);
          formData.append('patient_age', this.patient_age4);
          formData.append('patient_gender', this.patient_gender4);
          formData.append('patient_id', this.patient_id4);
          formData.append('patient_date', this.patient_date4);
          formData.append('patient_date', this.patient_date4);
          formData.append('task_number', 2);
          if(this.filetype4 == 'BrainTumors'){
            formData.append('algorithm_name', 'Brain Tumors');
          }
          if(this.file4 != null){
            formData.append('data_file', this.file4);
          }
          formData.append('input_image', this.inputImage4);
          // formData.append('no_of_features', this.features4);
          // if(this.inputAttrList4.length >= 1){
          //   for(var i = 0; i < this.inputAttrList4.length; i++){
          //       this.my_features_data4.push([this.inputAttrList4[i].forecast_val])
          //   }
          // }else{
          //   for(var i = 0; i < this.attributes4.length; i++){
          //     this.my_features_data4.push([this.attributes4[i].forecast_val])
          //   }
          // }
          // formData.append('features', this.my_features_data4);
        //   if(this.inputAttrList4.length >= 1){
        //   Object.keys(this.inputAttrList4).map((index) => {
        //     this.my_feature_label4['x' + (parseInt(index) + 1) ] = this.inputAttrList4[index].value
        //   });
        // }
        // else{
        //   Object.keys(this.attributes4).map((index) => {
        //     this.my_feature_label4['x' + (parseInt(index) + 1) ] = this.attributes4[index].forecast_label
        //   });}
        //   formData.append('input_attributes', JSON.stringify(this.my_feature_label4));
            if(this.filetype4 == 'BrainTumors'){
              this.$store.dispatch('createBrainTumourDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader4 = false
                    this.resultData4 = res.data
                    this.uploadingLoader1 = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                  this.errMsgShow4 = true
                  this.errMsg4 = err.data
                  this.uploadingLoader1 = false
                  this.algorithm_loader4 = false
              },8000)
              })
            }
          return
        }
      });
    },
    updateTask4() {
      this.taskEditAble4 = false
    },
    updatedTask4() {
      this.taskEditAble4 = true
    },
    addNewAttributes4 : function () {
      this.attributes4.push(Vue.util.extend({}, this.attribute))
      this.features4 = this.attributes4.length
    },
    addApiNewAttributes: function () {
      this.inputAttrList4.push(Vue.util.extend({}, this.local_Array4))
      this.features4 = this.inputAttrList4.length
    },
    removeApiAttributes : function (index) {
      Vue.delete(this.inputAttrList4, index);
      this.features4 = this.inputAttrList4.length
    },
    removeAttributes4 : function (index) {
      Vue.delete(this.attributes4, index);
      this.features4 = this.attributes4.length
    },
    updateAttributes4(index){
      $('.updateAttributes' + index).addClass('d-none')
      $('.updatedAttributes' + index).removeClass('d-none')
    },
    updatedAttributes4(index){
      $('.updateAttributes' + index).removeClass('d-none')
      $('.updatedAttributes' + index).addClass('d-none')
    }
  },
  watch:{
    // getInputAttrListed1Fun() {
    //   this.$store.dispatch('getInputAttrListFun',{id:2}).then((res) => {
    //   this.inputAttrList4 = this.$store.getters.getInputAttrListGetters.data
    //   if(this.inputAttrList4 && this.inputAttrList4.length >= 1){
    //     this.features4 = this.inputAttrList4.length
    //   }else{
    //     this.features4 = this.attributes4.length
    //   }
    //   }).catch((err)=>{
        
    //   })
    //   return
    // }
  },
}